import * as React from 'react';
import { Link } from 'react-router';

import URI from 'jsuri';
import PropTypes from 'prop-types';
import type { LegacyContextType } from 'types/legacy-context-types';
import _ from 'underscore';
import connectToStores from 'vendor/cnpm/fluxible.v0-4/addons/connectToStores';

import connectToRouter from 'js/lib/connectToRouter';
import { FormattedMessage } from 'js/lib/coursera.react-intl';
import { tupleToStringKey } from 'js/lib/stringKeyTuple';

import getCurrentSocialProfile from 'pages/open-course/common/models/currentSocialProfile';
import groupAuthorizationPromise from 'pages/open-course/common/promises/groupAuthorizationPromise';

// FIXME: existing import/no-cycle violations are excused to prevent seeing errors when modifying other parts of the same file; please fix it carefully
// eslint-disable-next-line import/no-cycle
import { ProfileArea } from 'bundles/discussions';
import { fetchAnswers, fetchThread } from 'bundles/discussions/actions/ThreadDetailsActions';
import { getAnswerPosition } from 'bundles/discussions/api/threadDetailsUtils';
import ModerationDropdown from 'bundles/discussions/components/ModerationDropdown';
import NextViewLink from 'bundles/discussions/components/NextViewLink';
import SessionDetails from 'bundles/discussions/components/SessionDetails';
import SoftDelete from 'bundles/discussions/components/SoftDelete';
import DetailedQuestion from 'bundles/discussions/components/discussionsBody/DetailedQuestion';
import discussionsForumsHOC from 'bundles/discussions/components/discussionsForumsHOC';
import ForumsConnectedReplyCMLInput from 'bundles/discussions/components/repliesList/ForumsConnectedReplyCMLInput';
import RepliesList from 'bundles/discussions/components/repliesList/RepliesList';
import ThreadSettings from 'bundles/discussions/components/threadSettings/ThreadSettings';
import { answerSorts, answers, defaults, naptimeForumTypes, savingStates } from 'bundles/discussions/constants';
import { buildUrl } from 'bundles/discussions/utils/discussionsUrl';
import routerConnectToCurrentForum from 'bundles/discussions/utils/routerConnectToCurrentForum';
import { formatThreadLegendId } from 'bundles/discussions/utils/threadUtils';
import unreadTracker from 'bundles/discussions/utils/unreadTracker';

/* @ts-expect-error ts-migrate(7016) FIXME: Untyped import */
import GroupForumsV1 from 'bundles/naptimejs/resources/groupForums.v1';

/* @ts-expect-error ts-migrate(7016) FIXME: Untyped import */
import OnDemandCourseForumsV1 from 'bundles/naptimejs/resources/onDemandCourseForums.v1';

/* @ts-expect-error ts-migrate(7016) FIXME: Untyped import */
import OnDemandMentorForumsV1 from 'bundles/naptimejs/resources/onDemandMentorForums.v1';

import _t from 'i18n!nls/discussions';

import 'css!./__styles__/ThreadDetail';

const ANSWER_LIMIT = answers.limitPerPage;

class ThreadDetail extends React.Component {
  static propTypes = {
    questionId: PropTypes.string.isRequired,
    sort: PropTypes.string.isRequired,
    page: PropTypes.number.isRequired,
    backLink: PropTypes.string.isRequired,
    authenticated: PropTypes.bool.isRequired,
    isSuperuser: PropTypes.bool.isRequired,
    answerSavingState: PropTypes.string,
    answerId: PropTypes.string,
    commentId: PropTypes.string,
    question: PropTypes.object,
    isClosed: PropTypes.bool,
    isPinned: PropTypes.bool,
    latestNewThreadId: PropTypes.string,
    contextId: PropTypes.string,
    userId: PropTypes.number,
    courseId: PropTypes.string,
    courseSlug: PropTypes.string,
    currentForum: PropTypes.oneOfType([
      PropTypes.instanceOf(OnDemandCourseForumsV1),
      PropTypes.instanceOf(OnDemandMentorForumsV1),
      PropTypes.instanceOf(GroupForumsV1),
    ]),
    currentForumUrl: PropTypes.string,
    hasModerationRole: PropTypes.bool,
  };

  static contextTypes = {
    executeAction: PropTypes.func.isRequired,
    router: PropTypes.object.isRequired,
  };

  declare context: LegacyContextType<typeof ThreadDetail.contextTypes>;

  state = {
    canTeach: false,
    inputClickCounter: 0,
  };

  componentWillMount() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'questionId' does not exist on type 'Read... Remove this comment to see the full error message
    const { questionId, sort, page, answerId, userId, courseId, courseSlug, contextId, currentForum } = this.props;

    this.context.executeAction(fetchThread, {
      questionId,
      userId,
      contextId,
      sort,
      page,
      forumType: currentForum && currentForum.forumType.typeName,
    });

    // Load replies if current url is not a deep link and if we are on the first page with default sort
    if (!answerId && (page !== 1 || sort !== defaults.detailSort)) {
      this.context.executeAction(fetchAnswers, {
        questionId,
        userId,
        courseId,
        courseSlug,
        contextId,
        sort,
        page,
        forumType: currentForum && currentForum.forumType.typeName,
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'hasModerationRole' does not exist on typ... Remove this comment to see the full error message
        includeDeleted: this.props.hasModerationRole,
      });
    }
  }

  componentDidMount() {
    this.getRole();
    this.fetchAnswerPosition();
    // @ts-expect-error ts-migrate(2339) FIXME: Property '_isMounted' does not exist on type 'Thre... Remove this comment to see the full error message
    this._isMounted = true;
  }

  componentWillReceiveProps(nextProps: $TSFixMe) {
    const { questionId, userId, courseId, courseSlug, contextId, sort, page, currentForum } = nextProps;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'sort' does not exist on type 'Readonly<{... Remove this comment to see the full error message
    if (nextProps.sort !== this.props.sort || nextProps.page !== this.props.page) {
      this.context.executeAction(fetchAnswers, {
        questionId,
        userId,
        courseId,
        courseSlug,
        contextId,
        sort,
        page,
        forumType: currentForum && currentForum.forumType.typeName,
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'hasModerationRole' does not exist on typ... Remove this comment to see the full error message
        includeDeleted: this.props.hasModerationRole,
      });
    } else if (
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'answerSavingState' does not exist on typ... Remove this comment to see the full error message
      this.props.answerSavingState === savingStates.SAVING &&
      nextProps.answerSavingState === savingStates.SAVED
    ) {
      this.context.executeAction(fetchAnswers, {
        questionId,
        userId,
        courseId,
        courseSlug,
        contextId,
        sort,
        page,
        forumType: currentForum && currentForum.forumType.typeName,
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'hasModerationRole' does not exist on typ... Remove this comment to see the full error message
        includeDeleted: this.props.hasModerationRole,
      });
      this.context.router.push({
        pathname: window.location.pathname,
        params: {},
        query: { sort: answerSorts.newestSort },
      });
    }
  }

  componentDidUpdate(prevProps: $TSFixMe) {
    if (
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'questionId' does not exist on type 'Read... Remove this comment to see the full error message
      prevProps.questionId !== this.props.questionId ||
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'currentForum' does not exist on type 'Re... Remove this comment to see the full error message
      (prevProps.currentForum && prevProps.currentForum.id !== this.props.currentForum.id)
    ) {
      this.markRead();
    }
  }

  componentWillUnmount() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property '_isMounted' does not exist on type 'Thre... Remove this comment to see the full error message
    this._isMounted = false;
  }

  getRole() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'authenticated' does not exist on type 'R... Remove this comment to see the full error message
    const { authenticated, isSuperuser, currentForum } = this.props;
    const groupId = currentForum && currentForum.forumType.definition.groupId;

    if (groupId) {
      groupAuthorizationPromise(groupId, authenticated, isSuperuser).then((canTeach: $TSFixMe) => {
        // @ts-expect-error ts-migrate(2339) FIXME: Property '_isMounted' does not exist on type 'Thre... Remove this comment to see the full error message
        if (this._isMounted) {
          this.setState({ canTeach });
        }
      });
    } else {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'hasModerationRole' does not exist on typ... Remove this comment to see the full error message
      this.setState({ canTeach: this.props.hasModerationRole });
    }
  }

  getBackLinkDescription() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'currentForum' does not exist on type 'Re... Remove this comment to see the full error message
    return this.props.currentForum.title;
  }

  fetchAnswerPosition = (answerID = '') => {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'answerId' does not exist on type 'Readon... Remove this comment to see the full error message
    const { answerId, questionId, courseId, courseSlug, userId, contextId, currentForum, currentForumUrl, sort, page } =
      this.props;
    const computedAnswerId = answerID || answerId;
    if (!computedAnswerId) return;
    const courseForumAnswerId = tupleToStringKey([courseId, computedAnswerId]);
    getAnswerPosition(courseForumAnswerId, sort, ANSWER_LIMIT)
      .then((pageNumber) => {
        if (pageNumber === page) {
          this.context.executeAction(fetchAnswers, {
            questionId,
            courseId,
            courseSlug,
            userId,
            contextId,
            sort,
            page,
            forumType: currentForum && currentForum.forumType.typeName,
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'hasModerationRole' does not exist on typ... Remove this comment to see the full error message
            includeDeleted: this.props.hasModerationRole,
          });
        } else {
          this.context.router.replace({
            pathname: this.context.router.location.pathname,
            params: {},
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'queryPairs' does not exist on type 'Uri'... Remove this comment to see the full error message
            query: Object.assign(_.object(new URI(this.context.router.location.search).queryPairs), {
              page: pageNumber,
            }),
          });
        }
      })
      .fail(() => {
        // If the answer/comment position lookup fails, handle it gracefully by defaulting to the first page
        const link = currentForumUrl;
        this.context.router.replace(buildUrl(link, questionId));
        this.context.executeAction(fetchAnswers, {
          userId,
          courseId,
          courseSlug,
          contextId,
          questionId,
          sort: defaults.detailSort,
          page: defaults.detailPage,
          forumType: currentForum && currentForum.forumType.typeName,
          // @ts-expect-error ts-migrate(2339) FIXME: Property 'hasModerationRole' does not exist on typ... Remove this comment to see the full error message
          includeDeleted: this.props.hasModerationRole,
        });
      })
      .done();
  };

  markRead() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'questionId' does not exist on type 'Read... Remove this comment to see the full error message
    unreadTracker.markRead(this.props.questionId);
  }

  render() {
    const {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'question' does not exist on type 'Readon... Remove this comment to see the full error message
      question,

      // @ts-expect-error ts-migrate(2339) FIXME: Property 'isClosed' does not exist on type 'Readon... Remove this comment to see the full error message
      isClosed,

      // @ts-expect-error ts-migrate(2339) FIXME: Property 'isPinned' does not exist on type 'Readon... Remove this comment to see the full error message
      isPinned,

      // @ts-expect-error ts-migrate(2339) FIXME: Property 'currentForumUrl' does not exist on type ... Remove this comment to see the full error message
      currentForumUrl,

      // @ts-expect-error ts-migrate(2339) FIXME: Property 'currentForum' does not exist on type 'Re... Remove this comment to see the full error message
      currentForum,

      // @ts-expect-error ts-migrate(2339) FIXME: Property 'sort' does not exist on type 'Readonly<{... Remove this comment to see the full error message
      sort,

      // @ts-expect-error ts-migrate(2339) FIXME: Property 'page' does not exist on type 'Readonly<{... Remove this comment to see the full error message
      page,

      // @ts-expect-error ts-migrate(2339) FIXME: Property 'questionId' does not exist on type 'Read... Remove this comment to see the full error message
      questionId,

      // @ts-expect-error ts-migrate(2339) FIXME: Property 'answerId' does not exist on type 'Readon... Remove this comment to see the full error message
      answerId,

      // @ts-expect-error ts-migrate(2339) FIXME: Property 'latestNewThreadId' does not exist on typ... Remove this comment to see the full error message
      latestNewThreadId,

      // @ts-expect-error ts-migrate(2339) FIXME: Property 'commentId' does not exist on type 'Reado... Remove this comment to see the full error message
      commentId,
    } = this.props;

    const forumLink = currentForumUrl;
    const forumType = currentForum && currentForum.forumType.typeName;

    const { mentorForumType, groupForumType } = naptimeForumTypes;
    const isCourseForumType = currentForum && [mentorForumType, groupForumType].indexOf(forumType) < 0;

    const shouldShowMoveThread = isCourseForumType;
    const shouldShowSessionDetails = this.state.canTeach && question && isCourseForumType;

    const threadLegendId = question ? formatThreadLegendId(question) : 'undefined-thread-legend';
    const currentSocialProfile = getCurrentSocialProfile();

    return (
      <div className="rc-ThreadDetail">
        {question && (
          <h2 id={threadLegendId} className="screenreader-only">
            <FormattedMessage message={_t('Thread: {title}')} title={question.content.question} />
          </h2>
        )}

        {shouldShowSessionDetails && <SessionDetails question={question} />}
        {latestNewThreadId === questionId && (
          <div className="sr-only" aria-live="polite">
            <FormattedMessage message={_t('Your new thread was created')} />
          </div>
        )}

        <div className="discussion-content">
          <div className="horizontal-box align-items-vertical-center align-items-spacebetween">
            {/* @ts-expect-error ts-migrate(2339) FIXME: Property 'backLink' does not exist on type 'Readon... Remove this comment to see the full error message */}
            <Link to={this.props.backLink} className="back-area nostyle">
              <div className="horizontal-box align-items-vertical-center">
                <i className="back-arrow cif-arrow-left c-back-arrow-image" />
                <h2 className="headline-2-text c-back-label">{this.getBackLinkDescription()}</h2>
              </div>
            </Link>

            {this.state.canTeach && question && (
              <ThreadSettings question={question} shouldShowMoveThread={shouldShowMoveThread} />
            )}
          </div>

          <div className="frost-container">
            <div>
              <DetailedQuestion
                goToInput={() =>
                  this.setState({
                    inputClickCounter: this.state.inputClickCounter + 1,
                  })
                }
                question={question}
                isPinned={isPinned}
                forumLink={forumLink}
              />

              {isClosed && (
                <div className="c-thread-locked card-no-action color-secondary-text">
                  <div className="horizontal-box align-items-absolute-center">
                    <i className="cif-lock" />
                    {_t('This thread is closed. You cannot add any more responses.')}
                  </div>
                </div>
              )}
            </div>

            <div>
              {question && (
                <RepliesList
                  // @ts-expect-error ts-migrate(2322) FIXME: Type '{ page: any; sort: any; answerId: any; comme... Remove this comment to see the full error message
                  page={page}
                  sort={sort}
                  answerId={answerId}
                  commentId={commentId}
                  forumLink={forumLink}
                  questionId={questionId}
                  fetchAnswerPosition={this.fetchAnswerPosition}
                />
              )}

              {!isClosed && (
                <div className="reply-container horizontal-box">
                  <ProfileArea
                    externalUserId={currentSocialProfile.get('externalUserId')}
                    fullName={currentSocialProfile.get('fullName')}
                    profileImageUrl={currentSocialProfile.getProfileImageUrl()}
                  />

                  {question && (
                    <ForumsConnectedReplyCMLInput
                      question={question}
                      parentPost={question}
                      // @ts-expect-error ts-migrate(2339) FIXME: Property 'answerSavingState' does not exist on typ... Remove this comment to see the full error message
                      savingState={this.props.answerSavingState}
                      shouldFocusCounter={this.state.inputClickCounter}
                      ariaLabel={_t('Reply to this thread')}
                      ariaDescribedBy={threadLegendId}
                    />
                  )}
                </div>
              )}

              {question && question.state && question.state.deleted && (
                <SoftDelete entry={question} hideUndoDelete={false} />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default _.compose(
  connectToStores(
    ['ThreadDetailsStore', 'ThreadsStore', 'ThreadSettingsStore', 'CourseStore', 'ApplicationStore'],
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'questionId' does not exist on type '{}'.
    ({ ThreadDetailsStore, ThreadsStore, ThreadSettingsStore, CourseStore, ApplicationStore }, { questionId }) => {
      const question = ThreadDetailsStore.getQuestion(questionId);
      const newThreadId = ThreadsStore.threadToInsert && ThreadsStore.threadToInsert.questionId;
      return {
        question,
        courseId: CourseStore.getCourseId(),
        courseSlug: CourseStore.getCourseSlug(),
        answerSavingState: question && ThreadDetailsStore.savingStates[question.id],
        isClosed: ThreadSettingsStore.isClosed(),
        isPinned: ThreadSettingsStore.isPinned(),
        latestNewThreadId: newThreadId,
        userId: ApplicationStore.getUserData().id,
        authenticated: ApplicationStore.isAuthenticatedUser(),
        isSuperuser: ApplicationStore.isSuperuser(),
      };
    }
  ),
  discussionsForumsHOC({
    fields: ['link', 'title'],
    subcomponents: [NextViewLink, ForumsConnectedReplyCMLInput, ModerationDropdown],
  }),
  connectToRouter(routerConnectToCurrentForum)
)(ThreadDetail);
